import React from 'react';
import ReactDOM from 'react-dom';

import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import 'bootstrap/dist/css/bootstrap.min.css';

import createRoutes from './router';
import { msalConfig } from './config/authConfig';

const routes = createRoutes();

const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();
if (accounts && accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      // Set the active account - this simplifies token acquisition
      const authResult = event.payload;
      msalInstance.setActiveAccount(authResult.account);
    }
  });
}

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      {routes}
    </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
